module.exports = __webpack_public_path__ + "img/28_55.47aeda22.png";